import React from 'react';
import { Menu } from '@blueprintjs/core';

import { useI18n } from 'i18n';
import NavLinkItem from './NavLinkItem';
import { AllRoutes } from 'constants/routes';

import './settingsMenu.scss';

export const MonitoringMenu = () => {
  const { fc } = useI18n();

  const menuItems = [
    // { title: fc('broadcast message'), url: AllRoutes.BroadcastMessage },
    { title: fc('airside vehicle monitoring'), url: AllRoutes.VehiclesMonitoring },
  ];

  return (
    <Menu className="settings-menu">
      {menuItems.map(({ title, url }, index) => (
        <NavLinkItem key={index} to={url}>
          {title}
        </NavLinkItem>
      ))}
    </Menu>
  );
};
